module.exports = __webpack_public_path__ + "img/sandwich.70a1795d.png";